export default __webpack_public_path__ + "static/media/LabFuturo.45a37cde.svg";